<template>
  <div>
    <van-pull-refresh v-model="state.refreshing" @refresh="onRefresh">
      <div :style="{ backgroundImage: `url(${homeTopBg})` }" class="relative bg-cover h-422px">
        <div class="flex justify-between items-center py-32px px-12px">
          <div class="flex items-center">
            <van-image
              class="flex-shrink-0"
              round
              :width="transPxToRem(48)"
              :height="transPxToRem(48)"
              :src="userInfo.avatarUrl || 'https://x.jzbull.com/x_dsx_wxapp/icons/default-head.png'"
            />
            <div class="ml-8px">
              <div class="flex items-center">
                <div class="leading-17px h-17px text-16px font-500 max-w-135px van-ellipsis">
                  {{ userInfo.nickname }}
                </div>
                <van-image
                  class="custom-rank"
                  :width="transPxToRem(41.1)"
                  :height="transPxToRem(19.2)"
                  :src="userInfo.agentInfo.customLevelIcon"
                  v-if="userInfo.agentInfo.customLevelIcon"
                />
                <RoleTag v-else :level="userInfo.agentInfo.agentLevel" :levelName="userInfo.agentInfo.agentLevelName" />
              </div>
              <div class="flex text-12px mt-10px">
                <div class="text-666 mr-4px">ID:{{ userInfo.puid }}</div>
                <div class="text-[#FD7F5C]" @click="copyLink(userInfo.puid)">[复制]</div>
              </div>
            </div>
          </div>
          <div class="relative flex flex-shrink-0">
            <div v-if="yaoqingjiameng && isInWxapp" class="mr-10px flex-c flex-col">
              <SvgIcon
                name="icon-yaoqingjiameng2"
                @click="toOnePage(yaoqingjiameng, 'wxapp')"
                :size="transPxToRem(28)"
              />
              <div class="mt-4px text-10px">邀请加盟</div>
            </div>
            <div class="flex-c flex-col" v-if="isInWxapp">
              <span v-if="unReadCount > 0" class="bg-[#FD4135] w-6px h-6px rounded-full absolute right-0 top-0"></span>
              <SvgIcon name="icon-a-xiaoxi" @click="toNotice()" :size="transPxToRem(28)" />
              <div class="mt-4px text-10px">公告</div>
            </div>
            <div class="flex-c flex-col" v-if="!isInWxapp">
              <van-icon :name="logoutIcon" size="22px" @click="logout" />
              <div class="mt-8px text-10px">退出</div>
            </div>
          </div>
        </div>
        <div class="px-16px">
          <div
            class="text-white h-152px pt-16px pl-16px rounded-12px bg-cover"
            :style="{ backgroundImage: `url(${homeDataBg})` }"
          >
            <div class="flex justify-between">
              <van-popover
                v-model:show="showPopover"
                placement="bottom-start"
                overlay
                :actions="dataActions"
                @select="onSelectDate"
              >
                <template #reference>
                  <div class="flex">
                    <div class="font-500">{{ popoverText }}&nbsp;</div>
                    <SvgIcon name="icon-sanjiaoxing-xia" :size="transPxToRem(8)" color="#ffffff" />
                  </div>
                </template>
              </van-popover>
              <div class="flex items-center">
                <van-icon
                  name="question-o"
                  v-if="!isRiskComplaint"
                  @click.stop="toggleExplain()"
                  :size="transPxToRem(14)"
                  color="#999"
                />
                <div
                  class="ml-5px pl-10px pr-5px text-12px py-4px bg-white bg-opacity-20"
                  :style="{
                    borderRadius: `${transPxToRem(100)} 0 0 ${transPxToRem(100)}`
                  }"
                  @click="openBoardSetting"
                >
                  设置&nbsp;<van-icon name="arrow" />
                </div>
              </div>
            </div>
            <div class="flex justify-between text-center pr-16px mt-16px">
              <div v-for="item in chunkBoardList[popoverIndex]" :key="item.text" @click="dataToPage(item.text)">
                <div class="mb-8px leading-16px h-16px text-12px text-white text-opacity-50">
                  {{ item.text }}({{
                    isOpenDataEdit
                      ? item.text.indexOf('单') != -1
                        ? '笔'
                        : balanceUnit(item.value + parseInt(item.addNumber)).company
                      : item.text.indexOf('单') != -1
                      ? '笔'
                      : balanceUnit(item.value).company
                  }})
                </div>
                <div class="text-[#F3D7B4] text-20px leading-20px h-20px num-font">
                  <template v-if="isHideBoardListNumber"> *** </template>
                  <template v-else>
                    {{
                      isOpenDataEdit
                        ? item.text.indexOf('单') != -1
                          ? item.value + parseInt(item.addNumber)
                          : balanceUnit(item.value + parseInt(item.addNumber)).balance_c
                        : item.text.indexOf('单') != -1
                        ? item.value
                        : balanceUnit(item.value).balance_c
                    }}
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="px-12px pt-28px pb-16px h-200px rounded-12px overflow-hidden bg-cover absolute w-full left-0 z-1 bottom-0 backdrop-filter backdrop-blur-10px"
          :style="{ backgroundImage: `url(${homeBonusBg})` }"
        >
          <div class="flex items-center">
            <div class="h-12px w-3px bg-[#FD7F5C] rounded-2px"></div>
            <div class="ml-4px font-500 text-14px">我的奖金</div>
            <div
              class="ml-8px text-12px text-999"
              v-if="isRiskComplaint && projectInfo?.projectRule === 'qiwangzhenxuan'"
              @click="
                showDialog({
                  confirmButtonText: '知道了',
                  message:
                    'SVIP分享转发商品链接给直推用户，用户下单购买后SVIP可获得奖金（即佣金），计算规则：可在商品详情点击“查看预估赚”可查看分享商品的预估赚多少。'
                })
              "
            >
              如何获得奖金？
            </div>
          </div>
          <div class="pl-40px mt-25px">
            <div class="grid grid-cols-2 col-auto gap-x-40px gap-y-25px">
              <div class="flex items-center" v-for="(item, index) in bonusList" :key="item.key">
                <div
                  class="w-147px"
                  @click="
                    item.key === 'totalIncome' || isRiskComplaint ? () => {} : toPageNew('/bonusDetail', 1, '奖金收入')
                  "
                >
                  <div class="text-12px text-999 mb-4px flex items-center">
                    <div class="h-24px leading-24px">
                      {{ `${item.title}(${item.unit})` }}
                    </div>
                    <SvgIcon
                      color="#999"
                      :size="transPxToRem(24)"
                      :name="payHide ? 'icon-biyan' : 'icon-zhengyan'"
                      v-if="item.key === 'totalIncome'"
                      @click.stop="changeMoneyHide(3)"
                    />
                    <SvgIcon
                      color="#999"
                      :size="transPxToRem(24)"
                      :name="bonusHide ? 'icon-biyan' : 'icon-zhengyan'"
                      v-if="item.key === 'totalBonus'"
                      @click.stop="changeMoneyHide(4)"
                    />
                  </div>
                  <div class="text-20px num-font">
                    <template v-if="item.key === 'totalBonus'">{{ bonusHide ? '***' : item.money }}</template>
                    <template v-else-if="item.key === 'totalIncome'">{{ payHide ? '***' : item.money }}</template>
                    <template v-else>{{ item.money }}</template>
                  </div>
                </div>
                <div v-if="(index + 1) % 2 !== 0" class="van-hairline--right h-32px bg-[#D8D8D8]"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bg-white rounded-8px px-12px pt-16px m-10px">
        <div class="flex justify-between">
          <div class="flex items-center">
            <div class="h-12px w-3px bg-[#FD7F5C] rounded-2px"></div>
            <div class="ml-4px font-500 text-14px">我的资产</div>
          </div>
          <div class="flex items-center text-999" @click.stop="toggleMyFund()">
            <div>{{ !myFundState ? '收起' : '展开' }}&nbsp;</div>
            <van-icon :name="!myFundState ? 'arrow-up' : 'arrow-down'" />
          </div>
        </div>
        <div class="wallet-content" v-if="!myFundState">
          <div
            class="wallet-item"
            style="background: linear-gradient(180deg, #fef9ec 0%, rgba(254, 249, 237, 0.2) 100%)"
            @click.stop="toPage('/yck')"
            v-if="!isRiskComplaint && isShowDepositWallet"
          >
            <div class="text-12px flex">
              <div>{{ depositName }}(元)</div>
              <SvgIcon
                color="#222"
                :size="transPxToRem(24)"
                :name="preHide ? 'icon-biyan' : 'icon-zhengyan'"
                @click.stop="changeMoneyHide(1)"
              />
            </div>
            <!-- <div class="mt-11px mb-13px flex items-end"> -->
            <!-- <div class="text-16px font-bold leading-24px h-24px">￥</div> -->
            <div class="mt-11px mb-13px text-24px leading-28px h-28px num-font">
              {{ preHide ? '***' : state.preBalance }}
            </div>
            <!-- </div> -->
            <div
              class="w-80px leading-28px h-28px rounded-14px border-solid border-[#F6DFA4] border flex justify-center"
              style="background: linear-gradient(180deg, #fdf0ce 0%, #fadda0 100%)"
              @click.stop="toPage('/yckcz')"
            >
              <div class="text-[#795020] text-13px">&nbsp;充值&nbsp;</div>
              <van-icon color="#795020" name="arrow" />
            </div>
          </div>
          <div
            class="wallet-item"
            style="background: linear-gradient(180deg, #fef9ec 0%, rgba(254, 249, 237, 0.2) 100%)"
            @click="state.isMultipleWallet ? toPage('/walletList') : toPage('/wallet?walletSource=0')"
          >
            <div class="text-12px flex">
              <div>我的钱包(元)</div>
              <SvgIcon
                color="#222"
                :size="transPxToRem(24)"
                :name="walletHide ? 'icon-biyan' : 'icon-zhengyan'"
                @click.stop="changeMoneyHide(2)"
              />
            </div>
            <!-- <div class="mt-11px mb-13px flex items-end"> -->
            <!-- <div class="text-16px font-bold leading-24px h-24px">￥</div> -->
            <div class="mt-11px mb-13px text-24px leading-28px h-28px num-font">
              {{ walletHide ? '***' : state.walletTotal }}
            </div>
            <div
              class="w-80px leading-28px h-28px rounded-14px border-solid border-[#F6DFA4] border flex justify-center"
              style="background: linear-gradient(180deg, #fdf0ce 0%, #fadda0 100%)"
              @click.stop="state.isMultipleWallet ? toPage('/walletList') : toPage('/cash?walletSource=0')"
            >
              <div class="text-[#795020] text-13px">&nbsp;{{ state.isMultipleWallet ? '查看' : '提现' }}&nbsp;</div>
              <van-icon color="#795020" name="arrow" />
            </div>
          </div>
          <div
            v-if="state.purchaseOpen"
            class="wallet-item"
            style="background: linear-gradient(180deg, #fef9ec 0%, rgba(254, 249, 237, 0.2) 100%)"
            @click="toPage('/goodsPayment/paymentAccount')"
          >
            <div class="text-12px flex">
              <div>货款账户(元)</div>
              <SvgIcon
                color="#222"
                :size="transPxToRem(24)"
                :name="walletHide3 ? 'icon-biyan' : 'icon-zhengyan'"
                @click.stop="changeMoneyHide(6)"
              />
            </div>
            <div class="mt-11px mb-13px text-24px leading-28px h-28px num-font">
              {{ walletHide3 ? '***' : state.purchaseWallet }}
            </div>
            <div
              class="w-80px leading-28px h-28px rounded-14px border-solid border-[#F6DFA4] border flex justify-center"
              style="background: linear-gradient(180deg, #fdf0ce 0%, #fadda0 100%)"
            >
              <div class="text-[#795020] text-13px">&nbsp;查看&nbsp;</div>
              <van-icon color="#795020" name="arrow" />
            </div>
          </div>
        </div>
      </div>

      <div class="bg-white rounded-8px px-12px py-16px m-10px">
        <div class="flex items-center mb-14px">
          <div class="h-12px w-3px bg-[#FD7F5C] rounded-2px"></div>
          <div class="ml-4px font-500 text-14px">常用功能</div>
        </div>
        <div class="text-center grid grid-cols-4 col-auto gap-x-4px gap-y-22px">
          <div
            class="relative"
            v-for="(item, index) in myToolList"
            :key="index"
            @click="toPageNew(item.url, item.type, item.name)"
          >
            <div
              class="text-white absolute left-50px top-2px h-16px bg-[#FD4135] rounded-8px border border-solid border-1px border-white-1px px-4px border-white text-center min-w-11px leading-15px text-11px z-1"
              v-if="item.url === '/team'"
            >
              {{ state.pageParam.teamCount > 99 ? '99+' : state.pageParam.teamCount }}
            </div>
            <van-image :src="item.icon" :width="transPxToRem(56)" :height="transPxToRem(56)" />
            <div class="mt-8px text-13px text-666">{{ item.name }}</div>
          </div>
        </div>
      </div>

      <div class="bg-white rounded-8px px-12px m-10px py-16px">
        <template v-for="(item, index) in navList" :key="index">
          <!-- <div v-if="index" class="h-1px bg-[#E5E5E5] my-20px"></div> -->
          <div class="py-20px" v-if="index">
            <div class="van-hairline--bottom"></div>
          </div>
          <div class="flex justify-between items-center" @click="toOnePage(item.url, item.type)">
            <div class="flex items-center">
              <SvgIcon :name="item.icon" :size="transPxToRem(24)" />
              <div class="ml-8px text-14px">
                {{
                  item.title == '团长须知'
                    ? state.pageParam?.commonTitle
                      ? state.pageParam?.commonTitle + '须知'
                      : '团长须知'
                    : item.title
                }}
              </div>
            </div>
            <div class="text-999 text-12px flex">
              <div class="mr-4px">
                {{ item.subject }} {{ item.count && item.count > 0 ? ':' : '' }}
                <span class="text-[#FD4135]" v-if="item.count">{{ item.count }}</span>
              </div>
              <van-icon name="arrow" color="#999" />
            </div>
          </div>
        </template>
      </div>
      <div class="pb-60px"></div>
      <!-- 说明显示设置 -->
      <van-popup
        safe-area-inset-bottom
        closeable
        :style="{ minHeight: '50%' }"
        position="bottom"
        round
        v-model:show="showExplain"
      >
        <div class="p-16px text-14px leading-22px">
          <div class="text-center text-16px font-500 mb-20px mt-5px">指标说明</div>
          <div class="mb-10px" v-for="(item, index) in explainArr" :key="index">
            <div class="text-font-500">{{ index + 1 }}.{{ item.title }}</div>
            <div>{{ item.des }}</div>
          </div>
          <div class="text-999 mb-20px">
            特别注意：订单成功支付时，上述指标加上相应数值，订单支付后发生“订单取消、仅退款、退货退款”时，上述指标减去相应数值。
          </div>
          <van-button color="linear-gradient( 170deg, #FFB695 0%, #FD7F5C 100%)" round block @click="toggleExplain()">
            知道了
          </van-button>
        </div>
      </van-popup>
      <!--数据看板设置-->
      <van-popup
        position="bottom"
        :style="{ minHeight: '50%', maxHeight: '90%' }"
        v-model:show="vanActionShow"
        closeable
        round
        safe-area-inset-bottom
      >
        <div class="text-center text-16px font-500 my-20px">数据看板设置</div>
        <div class="px-16px relative text-left">
          <div class="flex py-16px justify-between" style="border-bottom: 1px solid #f1f1f1">
            <div>
              <div class="text-14px font-500">隐藏数值</div>
              <div class="mt-8px text-12px text-666">开启后数值部分将会用“***”替代</div>
            </div>
            <van-switch
              style="margin-left: auto; box-sizing: content-box"
              v-model="isHideBoardListNumber"
              inactive-color="#D9D9D9"
              active-color="#FD7F5C"
              size="20px"
            />
          </div>
          <div class="flex py-16px justify-between" v-if="!isHideWow">
            <div>
              <div class="text-14px font-500">哇晒！</div>
              <div class="mt-8px text-12px text-666">建议谨慎使用该功能！</div>
            </div>
            <van-switch
              style="margin-left: auto; box-sizing: content-box"
              v-model="isOpenDataEdit"
              inactive-color="#D9D9D9"
              active-color="#FD7F5C"
              size="20px"
            />
          </div>
          <div v-show="isOpenDataEdit" class="edit-table-container pb-50px">
            <table>
              <tr style="background-color: #fafafa">
                <td>数据项</td>
                <td>当前数值</td>
                <td>
                  <div class="flex items-center flex-col">
                    <div>营销加值</div>
                    <div class="text-12px text-[#FD7F5C]" @click="batchToZero">批量复零</div>
                  </div>
                </td>
              </tr>
              <tr v-for="(item, index) in virtualBoardList" :key="index">
                <td>{{ item.text }}</td>
                <td>{{ item.value }}</td>
                <td>
                  <div class="flex flex-row justify-center items-center">
                    <div class="text-12px mr-5px">+</div>
                    <input
                      type="tel"
                      class="w-70px h-20px text-12px border border-1px border-[#eaeaea] border-solid px-5px"
                      v-model="item.addNumber"
                      maxlength="6"
                      oninput="this.value=this.value.replace(/[^\d]/g,'')"
                      onafterpaste="this.value=this.value.replace(/[^\d]/g,'')"
                    />
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <div v-show="isOpenDataEdit" class="fixed w-full left-0 bottom-0 p-16px">
            <van-button color=" linear-gradient( 170deg, #FFB695 0%, #FD7F5C 100%)" round block @click="saveUserBtn">
              保 存
            </van-button>
          </div>
        </div>
      </van-popup>
    </van-pull-refresh>
  </div>
</template>

<script setup>
import homeTopBg from '@/assets/img/home-top-bg.png'
import homeBonusBg from '@/assets/img/bonus-bg.png'
import homeDataBg from '@/assets/img/data-bg.png'
import logoutIcon from '@/assets/img/logout-icon.png'
import SvgIcon from '@/components/SvgIcon.vue'
import { useToggle } from '@vant/use'
import { reactive, onMounted, ref, computed } from 'vue'
import {
  getAgentOverview,
  getIndexPanelDataAPI,
  getNoticeListAPI,
  getAllProfitAPI,
  getAgentMean,
  getAgentOverviewJoinBlockApi,
  getDefaultAnnouncementApi
} from '@/api/home'
import RoleTag from '@/components/RoleTag'
import { useUserStore } from '@/store/user'
import { Image as VanImage, Popover as VanPopover, Switch as VanSwitch, showDialog, showConfirmDialog } from 'vant'
import { Toast } from '@vant/compat'
import usePage from '@/hooks/usePage'
// import heightStyle from '@/utils/height'
import { balanceUnit } from '@/common/js/utils'
import { deepClone, transPxToRem, chunkArray } from '@/utils'
// import { WxPage } from '@/enum'
import wx from 'weixin-js-sdk'
import { getBonusSummary } from '@/api/bonus'
import { useClipboard, useTitle } from '@vueuse/core'
import { useAppStore } from '@/store/app'

const explainArr = [
  {
    title: '今日/本月/上月单数',
    des: '是指今日/本月/上月订单数。'
  },
  {
    title: '今日/本月/上月自营',
    des: '是指今日/本月/上月店铺出单的销售额，依据的价格是销售价（注册用户/游客的价格）。'
  },
  {
    title: '今日/本月/上月收益',
    des: '是指今日/本月/上月所获各类奖金及自购省的利润总和。'
  },
  {
    title: '自购省的利润',
    des: '是指代理/准代理在自己店铺下单支付后，按销售价（注册用户价格）减去对应代理价的出的差。'
  }
]
const userApp = useAppStore()
const isInWxapp = computed(() => userApp.isInWxapp)
const unReadCount = ref(0)
const yaoqingjiameng = ref('')
const getUnReadNumber = async () => {
  const data = await getDefaultAnnouncementApi()
  unReadCount.value = data.unReadCount
}

const [myFundState, toggleMyFund] = useToggle()
const [showPopover] = useToggle()
const popoverIndex = ref(0)
const dataActions = [
  { text: '今日', className: '!w-112px' },
  { text: '本月', className: '!w-112px' },
  { text: '上月', className: '!w-112px' }
]
const popoverText = computed(() => dataActions.find((_, i) => i === popoverIndex.value).text)
const onSelectDate = (_, index) => {
  popoverIndex.value = index
}

const userStore = useUserStore()
const projectInfo = computed(() => userStore.getProjectInfo) //用户信息
const userInfo = computed(() => userStore.getUserInfo) //用户信息

const isRiskComplaint = computed(() => userStore.isRiskComplaint)
const isShowDepositWallet = computed(() => userStore.getSettingInfo?.isShowDepositWallet !== 0)
const depositName = computed(() => userStore.getDepositName)
const isAnxingtui = computed(() => ['anxingtui'].includes(projectInfo.value?.projectRule))
const isHideWowInAnxingtui = computed(() => isAnxingtui.value && ![1, 2].includes(userInfo.value.agentInfo?.subLevel))
const isHideWow = computed(
  () => isHideWowInAnxingtui.value || ['qianchuan', 'qiwangzhenxuan'].includes(projectInfo.value?.projectRule)
)
// const { fixHeight } = heightStyle()
const { navigateTo } = usePage()
const title = useTitle()
title.value = '代理后台'
const state = reactive({
  refreshing: false,
  loading: true,
  finished: false,
  list: [],

  pageParam: {},
  toast: false,
  appVersion: '',
  preBalance: 0,
  walletBalance: 0,
  sphWalletBalance: 0,
  bonusTotal: 0,
  isMultipleWallet: false,
  walletTotal: 0,
  purchaseWallet: 0,
  purchaseOpen: false
})

const preHide = ref(true)
const walletHide = ref(true)
const walletHide2 = ref(false)
const walletHide3 = ref(true)
const payHide = ref(false)
const bonusHide = ref(false)
const navList = ref([]) //底部入口导航
// const theme = computed(() => userStore.getTheme)
// const announcement = ref({}) //公告
const boardList = ref([]) //看板数据

const chunkBoardList = computed(() => chunkArray(boardList.value, 3))

const virtualBoardList = ref([]) //修改哇塞看板数据
const noticeList = ref([]) //公告通知
// const showBoardMore = ref(false) //控制数据面板开关
const vanActionShow = ref(false) //控制面板的展示
const isHideBoardListNumber = ref(false) //是否用*号代替数据
const isOpenDataEdit = ref(false) //是否打开数据编辑面板
// const showSaveBtn = ref(true) //是否显示保存按钮
const myToolList = ref([])
const bonusList = ref([
  { key: 'todayBonus', money: 0, title: '今日奖金', unit: '元' },
  { key: 'monthBonus', money: 0, title: '本月奖金', unit: '元' },
  { key: 'totalBonus', money: 0, title: '累计奖金', unit: '元' },
  { key: 'totalIncome', money: 0, title: '累计收益', unit: '元' }
]) // 奖金数据
state.appVersion = computed(() => userStore.getAppVersionState)
//隐藏金额显示事件
function changeMoneyHide(type) {
  switch (type) {
    case 1:
      preHide.value = !preHide.value
      break
    case 2:
      walletHide.value = !walletHide.value
      break
    case 3:
      payHide.value = !payHide.value
      break
    case 4:
      bonusHide.value = !bonusHide.value
      break
    case 5:
      walletHide2.value = !walletHide2.value
      break
    case 6:
      walletHide3.value = !walletHide3.value
      break
  }
}
const { copy } = useClipboard({ source: userInfo.value.puid })
//复制个人号
function copyLink(content) {
  copy(content)
  Toast('成功复制')
}

// function closeBoardModelOne() {
//   vanActionShow.value = false
// }
//批量复零
function batchToZero() {
  let resList = virtualBoardList.value
  for (let it of resList) {
    it.addNumber = 0
  }
  virtualBoardList.value = resList
}

// let signalToast = ref(false)
// function openSignalSetting() {
//   signalToast.value = !signalToast.value
// }
const [showExplain, toggleExplain] = useToggle()

//刷新页面
const onRefresh = () => {
  // 清空列表数据
  state.finished = false
  // 重新加载数据
  // 将 loading 设置为 true，表示处于加载状态
  state.loading = true
  getData()
}
function dataToPage(name) {
  if (name.indexOf('单数') != -1) {
    navigateTo('/dataStatistics')
  } else if (name.indexOf('自营') != -1 && projectInfo.value?.projectRule !== 'yixintuan') {
    navigateTo('/performance')
  }
}
const toPage = url => {
  console.log(url)
  navigateTo(url)
}
const toOnePage = (url, type) => {
  if (url == '') {
    Toast('更多功能程序员哥哥在准备中，敬请期待!')
  } else if (type == 'h5') {
    //跳页面
    navigateTo(url)
  } else if (type == 'wxapp') {
    //跳小程序页面
    if(isInWxapp.value){
      wx.miniProgram.navigateTo({ url })
    }else{
      Toast('该功能需要前往小程序查看')
    }
  }
}
function toNotice(id) {
  let url = ''
  if (id > 0) {
    //去公告详情
    url = `/packageA/pages/notice/noticedetail?id=${id}`
  } else {
    //去公告列表
    url = '/packageA/pages/notice/notice'
  }
  wx.miniProgram.navigateTo({ url })
}
function toPageNew(url, type, name) {
  if (name === '占位') return false
  if (type == 4) {
    Toast('功能升级中，请耐心等待哦')
  } else if (type == 1) {
    //跳页面
    navigateTo(url)
  } else if (type == 2) {
    //跳小程序页面
    if(isInWxapp.value){
      wx.miniProgram.navigateTo({ url })
    }else{
      Toast('该功能需要前往小程序查看')
    }
  } else {
    Toast('更多功能程序员哥哥在准备中，敬请期待!')
  }
}

//保存用户晒哇
function saveUserAddNumber() {
  let reList = virtualBoardList.value
  for (let i = 0; i < reList.length; i++) {
    if (reList[i].addNumber) {
      reList[i].addNumber = parseInt(reList[i].addNumber, 10)
    } else {
      reList[i].addNumber = 0
    }
  }
  virtualBoardList.value = reList
  sumBoardList()
}
function saveUserBtn() {
  saveUserAddNumber()
  vanActionShow.value = false
}

// const tips = () => {
//   Toast('敬请期待')
// }

//退出
const logout = () => {
  showConfirmDialog({
    title: '提示',
    message: '确定退出登录吗？'
  }).then(() => {
    userStore.logout()
  })
}

function sumBoardList() {
  let list = boardList.value
  for (let i = 0; i < list.length; i++) {
    list[i].addNumber = parseInt(virtualBoardList.value[i].addNumber, 10)
  }
  boardList.value = list
}
//切换面板展示数量
// function changeBoardStatus() {
//   showBoardMore.value = !showBoardMore.value
// }
//打开面板设置弹窗
function openBoardSetting() {
  vanActionShow.value = true
}
function getData() {
  Toast.loading({
    message: '加载中...',
    forbidClick: true
  })
  getOverview()
  getMyToolList()
  getAllProfit()
  getPanelData()
  getBonus()
}

async function getOverview() {
  state.pageParam = await getAgentOverview()
  state.loading = false
  state.finished = true
  state.refreshing = false
  // navList.value = state.pageParam.joinBlock.items
  userStore.setPayPassword(state.pageParam.isSetPayPassword)
  userStore.setNeedPayPassword(state.pageParam.cashingCheckPsw === 1)
  //获取默认公告
  let notice = await getNoticeListAPI({ page: 1, pageSize: 5 })
  noticeList.value = notice.list || []
}

async function getMyToolList() {
  try {
    const { list } = await getAgentMean()
    myToolList.value = list
  } catch (e) {
    console.log(e)
  }
}

async function getBonus() {
  try {
    // 获取奖金数据
    const bonusInfo = await getBonusSummary()
    bonusList.value.forEach(ele => {
      if (bonusInfo[ele.key] || bonusInfo[ele.key] === 0) {
        ele.money = bonusInfo[ele.key]
        ele.unit = '元'
      }
    })
  } catch (e) {
    console.log(e)
  }
}
async function getAllProfit() {
  try {
    const res = await getAllProfitAPI()
    state.preBalance = res.preBalance
    state.walletBalance = res.walletBalance
    state.bonusTotal = res.bonusTotal
    state.walletTotal = res.walletTotal
    state.isMultipleWallet = res.isMultipleWallet
    state.sphWalletBalance = res.sphWalletBalance || '0.00'
    state.purchaseOpen = res.purchaseOpen
    state.purchaseWallet = res.purchaseWallet
    bonusList.value = bonusList.value.map(d => {
      if (d.key === 'totalIncome') {
        d.money = res.bonusTotal
        d.title = res.profitTitle
      }
      return d
    })
  } catch (e) {
    console.log(e)
  }
}
async function getPanelData() {
  try {
    //获取数据看板
    let tempBoardList = []
    let userIndexData = await getIndexPanelDataAPI()
    for (let i = 0; i < userIndexData.columns.length; i++) {
      let col = userIndexData.columns[i].item
      for (let j = 0; j < col.length; j++) {
        col[j].addNumber = 0
        tempBoardList.push(col[j])
      }
    }
    boardList.value = tempBoardList
    if (!virtualBoardList.value.length) {
      //首次复制
      virtualBoardList.value = deepClone(boardList.value)
    }
    if (isOpenDataEdit.value) {
      sumBoardList()
    }
    Toast.clear()
  } catch (e) {
    console.log(e)
  }
}

const getAgentOverviewJoinBlock = async () => {
  try {
    const resData = await getAgentOverviewJoinBlockApi()
    navList.value = resData.joinBlock.items
    if (navList.value.some(it => it.title === '邀请加盟' && it.url === '/packageA/pages/union/union')) {
      yaoqingjiameng.value = '/packageA/pages/union/union'
    }
  } catch (e) {
    console.log(e)
  }
}

onMounted(async () => {
  const token = userStore.getTokenState
  if (token) {
    state.isLogin = true
  }
  getData()
  getAgentOverviewJoinBlock()
  getUnReadNumber()
})
</script>

<style lang="less" scoped>
.wallet-content {
  padding: 16px 0;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  .wallet-item {
    width: 160px;
    padding: 16px;
    height: 120px;
    border-radius: 16px;
    display: inline-block;
  }
  .wallet-item:not(:last-child) {
    margin-right: 10px;
  }
  .wallet-item:nth-last-child(n + 3):first-child,
  .wallet-item:nth-last-child(n + 3):first-child ~ .wallet-item {
    width: 128px;
  }
}
.wallet-content::-webkit-scrollbar {
  height: 0;
  display: none;
}

.wallet-content {
  ::-webkit-scrollbar,
  ::-webkit-scrollbar-track,
  ::-webkit-scrollbar-thumb,
  ::-webkit-scrollbar-button,
  ::-webkit-scrollbar-corner {
    display: none;
  }
}

.edit-table-container {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 20px;
}
.edit-table-container td {
  border: solid #f2f2f2;
  border-width: 0 1px 1px 0;
  padding: 10px 0;
  width: 33.333%;
  text-align: center;
  font-size: 13px;
  font-weight: 400;
  color: #222222;
}
.edit-table-container table {
  width: 100%;
  border: solid #f2f2f2;
  border-width: 1px 0 0 1px;
}
.num-font {
  font-family: DINAlternateBold;
}

.custom-rank {
  margin-left: 8px;
  width: 41.1px;
  height: 19.2px;
}
</style>
